import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Profile.css';
import Loading from '../../components/Loading/Loading';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const Profile = () => {
    const { id } = useParams();
    const numericId = parseInt(id, 10);
    const [data, setData] = useState([]);
    const [fields, setFields] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const lastDegree = [
        'کارشناسی',
        'کارشناسی ارشد',
        'دکترای تخصصی',
    ];

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem('token');
            const params = new URLSearchParams();
            if (!isNaN(numericId) && numericId !== 0) {
                params.set('id', numericId);
            }
            try {
                const response = await fetch(`${API_URL}/accounts/profile?` + params.toString(), {
                    method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                if (response.ok) {
                    const d = await response.json();
                    setData(d);
                } else {
                    const errorData = await response.json();
                    setModalData({
                        isVisible: true,
                        message: errorData.error,
                        type: 'error',
                    });
                }
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        setFields([
            { label: 'کد شناسایی استاد', value: data.professor_number, disabled: true },
            { label: 'نام', value: data.persian_fname, disabled: true },
            { label: 'نام خانوادگی', value: data.persian_lname, disabled: true },
            { label: 'کد‌ملی', value: data.national_number, disabled: true },
            { label: 'نام(eng)', value: data.english_fname, disabled: true },
            { label: 'نام خانوادگی(eng)', value: data.english_lname, disabled: true },
            { label: 'شماره همراه', value: data.phone_number, disabled: true },
            { label: 'شماره ثابت', value: data.fixed_number, disabled: true },
            { label: 'دانشکده', value: data.faculty, disabled: true },
            { label: 'گروه آموزشی', value: data.department, disabled: true },
            { label: 'جنسیت', value: data.gender, disabled: true },
            { label: 'پست الکترونیک دانشگاهی', value: data.email, disabled: true },
            { label: 'مرتبه علمی', value: data.scientific_rank, disabled: true },
            { label: 'پست الکترونیک شخصی', name: 'second_email', value: data.second_email, disabled: false },
            { label: 'پست سازمانی', name: 'organizational_post', value: data.organizational_post, disabled: false },
            { label: 'وبسایت شخصی۱', name: 'personal_website1', value: data.personal_website1, disabled: false },
            { label: 'وبسایت شخصی۲', name: 'personal_website2', value: data.personal_website2, disabled: false },
            { label: 'وبسایت شخصی۳', name: 'personal_website3', value: data.personal_website3, disabled: false },
            { label: 'رشته تحصیلی', name: 'fields', value: data.fields, disabled: false },
            { label: 'آخرین مدرک تحصیلی', name: 'last_degree', dropDown: true, value: lastDegree[data.last_degree] , disabled: false },
        ]);
    }, [data]);

    const handleChangeInput = (event) => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();   

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/accounts/profile`, {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            if (response.ok) {
                setModalData({
                    isVisible: true,
                    message: 'تغییرات پروفایل با موفقیت ثبت شد',
                    type: 'success',
                });
            } else {
                setShowError(true);
                const timer = setTimeout(() => {
                    setShowError(false);
                }, 3000);
                return () => clearTimeout(timer);
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        }
    }

    const handleUpdateProfile = async () => {
        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const body = {};
            if (!isNaN(numericId) && numericId !== 0) {
                body.user = numericId;
            }
            const response = await fetch(`${API_URL}/accounts/golestan-profile`, {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            if (response.ok) {
                const d = await response.json();
                setData(d);
                setModalData({
                    isVisible: true,
                    message: 'پروفایل با موفقیت بروزرسانی شد',
                    type: 'success',
                });
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="profile-container">
                {loading && (
                    <Loading />
                )}
                <div className={"profile-card"}>
                    <div className="card-header">
                        <h2 className="card-title">پروفایل</h2>
                    </div>
                    <div className="card-body">
                        <div className="profile-row">
                            <div className="profile-col">
                                <div className="profile-picture">
                                    <img
                                        src="/kntu.ico"
                                        alt="Profile"
                                        className="profile-image"
                                        onError={(event) => (event.target.src = "/real2.jpg")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="profile-form">
                            <div className="profile-row grid">
                                {fields.map((field, index) => (
                                    <div key={index} className="profile-col">
                                        <label className="form-label">{field.label}</label>
                                        {field.dropDown ? (
                                            <select className="form-label" name={field.name} value={data.last_degree} onChange={handleChangeInput}
                                            >
                                                <option className='light-text' value={''}>{'--------'}
                                                </option>
                                                {lastDegree.map((degree, index) => (
                                                    <option className="light-text" value={index + 1}
                                                    >       {degree}
                                                    </option>
                                                ))};
                                            </select>
                                        ) : (
                                            <>
                                                <input
                                                    value={field.value}
                                                    type="text"
                                                    name={field.name ? field.name : ""}
                                                    className="form-input"
                                                    disabled={field.disabled}
                                                    onChange={handleChangeInput}
                                                />
                                                {field.name === 'second_email' && !emailRegex.test(data.second_email) && showError && (<p className="error-text">پست الکترونیک معتبر نیست</p>)}
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                            <div className="profile-button-container">
                                <button className="profile-button btn medium-text" onClick={handleSubmit}>
                                    ذخیره
                                </button>
                                <button className="update-profile-button btn medium-text" onClick={handleUpdateProfile}>
                                    بروزرسانی پروفایل
                                </button>
                            </div>
                        </div>
                        <Modal
                            message={modalData.message}
                            type={modalData.type}
                            isVisible={modalData.isVisible}
                            onClose={() => setModalData({ ...modalData, isVisible: false })}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profile;
